import { DataBlockVariant, useDataBlockType } from '@lmt/shared-types';
import {
  DataBlockUiEditor,
  DataBlockUiEditorProps,
} from '@lmt/unicorn-shared/app/components/measurements/DataBlockUiEditor';
import { useClaims } from '@lmt/unicorn-shared/app/features/auth/operations';
import clsx from 'clsx';
import React, { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonColor } from '../common/ui-kit/buttons/Button';
import { FormComponentProps } from '../global-forms/GlobalForms.types';
import { caseInformationDataBlockTypeName } from './common';

import styles from '@lmt/unicorn-shared/app/components/global-forms/Content.module.scss';
import localStyles from './DataBlockStatistic.module.scss';
import { useEventCallback } from '@mui/material';

export type DataBlockStatisticProps = FormComponentProps & {
  dataBlockId: number;
  dataBlockTypeId: number;
};

export const DataBlockStatistic: FC<DataBlockStatisticProps> = (props) => {
  const {
    formType,
    formId,
    tryCompleteForm,
    dataBlockId,
    dataBlockTypeId,
    loadBlocking,
  } = props;

  const i18next = useTranslation();
  const claims = useClaims();
  const selectedDataBlockType = useDataBlockType(dataBlockTypeId);

  const actions: DataBlockUiEditorProps['actions'] = useRef(null);

  const onCancel = useEventCallback(async () => {
    await loadBlocking(formId, i18next.t('data_blocks.loading'), async () => {
      await tryCompleteForm(formType, formId, async () => undefined);
    });
  });

  const onSave = useEventCallback(async () => {
    await loadBlocking(
      formId,
      i18next.t('data_blocks.loading_save'),
      async () => {
        await tryCompleteForm(formType, formId, async () => {
          await actions.current?.save();
        }).catch((e) => console.error('DataBlockStatistic.onSave', e));
      },
    );
  });
  return (
    <div
      className={clsx(styles.autoSizedContainer, localStyles.container)}
      data-test-id="dataBlockViewPopup"
    >
      <div className={styles.dataContainer}>
        <DataBlockUiEditor
          dataBlockTypeId={props.dataBlockTypeId}
          dataBlockId={dataBlockId}
          type={'update_data_block'}
          isEditable={claims.permissions.dataBlockManagement}
          actions={actions}
          isStatistic={true}
        />
      </div>
      {claims.permissions.dataBlockManagement && (
        <div className={styles.submitContainer}>
          {(dataBlockId ||
            selectedDataBlockType?.variant === DataBlockVariant.Patient) && (
            <>
              <Button
                color={ButtonColor.Primary}
                disabled={
                  selectedDataBlockType?.variant === DataBlockVariant.Case &&
                  selectedDataBlockType?.value ===
                    caseInformationDataBlockTypeName
                }
                onClick={onCancel}
                title={i18next.t('data_blocks.cancel_button')}
                className={styles.submit}
              />

              <Button
                onClick={onSave}
                title={i18next.t('data_blocks.save_button')}
                className={styles.submit}
              />
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default DataBlockStatistic;
